// @flow
import { createMeta } from "../../../components/TapHeader";

const title = "Company Profile";
export const OrgProfileMeta = createMeta(title);
